import React from "react";
import { IconSize } from "../theme";

interface PlusProps {
  size?: string;
}

const Plus: React.FC<PlusProps> = ({ size = IconSize.M }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24">
      <path
        d="M12 5V19M5 12H19"
        stroke="#0a1440"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default Plus;
